import m from 'mithril';
import '@awesome.me/webawesome/dist/components/callout/callout.js';

/**
 * Inline alert attrs.
 */
export interface AlertAttrs extends m.Attributes {
  /** Alert title. */
  title?: string;
  /** Alert message. */
  message?: string;
  /** Alert variant. */
  variant?: 'brand' | 'neutral' | 'success' | 'warning' | 'danger';
  /** Additional CSS class names. */
  className?: string;
}

/**
 * Renders an accessible inline alert.
 */
export const Alert: m.Component<AlertAttrs> = {
  view: ({ attrs, children }) => {
    return m('wa-callout', {
      class: ['alert', attrs.className ?? ''].filter(Boolean).join(' '),
      variant: attrs.variant ?? 'brand',
      appearance: 'filled-outlined',
    }, [
      attrs.title ? m('strong', attrs.title) : null,
      attrs.message ? m('span', attrs.title ? ` ${attrs.message}` : attrs.message) : null,
      children,
    ]);
  },
};
